import React, { useContext } from "react";
import data from "./data";
import { NavContext } from "contexts/";
import MegaNav from "../MegaNav";
export default function Resources() {
	const section = data.sections.find(x => x.title.toLowerCase() === "webinars");
	if (section && section.items && section.items.length >= 1) {
		const { webinars } = useContext(NavContext);
		section.items = [section.items[0], ...webinars];
	}

	return <MegaNav data={data} left={"-17em"} />;
}
